import logoIcon from 'assets/images/leapx-mark.png';
import { useTheme } from '@mui/material/styles';

// ==============================|| LOGO — LeapX Hub 字组合 (V2 visual baseline) ||============================== //

const Logo = () => {
  const theme = useTheme();
  const dark = theme.palette.mode === 'dark';
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
      <img
        src={logoIcon}
        alt="LeapX Hub"
        height="34"
      />
      <span
        style={{
          fontFamily: "'Sora','Noto Sans SC',sans-serif",
          fontWeight: 800,
          fontSize: 21,
          letterSpacing: '-0.01em',
          lineHeight: 1,
          whiteSpace: 'nowrap'
        }}
      >
        <span style={{ color: dark ? '#FFFFFF' : '#0A0D1F' }}>LeapX</span>{' '}
        <span
          style={{
            background: 'linear-gradient(90deg,#C9A84C,#8B6520)',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: 'transparent'
          }}
        >
          Hub
        </span>
      </span>
    </span>
  );
};

export default Logo;
